import E6FormExtend from "./E6FormExtend";
import E6Title from "./E6Title";
import E6Breadcrumb from "./E6Breadcrumb";
import E6FlankFix from "./E6FlankFix";
import E6Pagination from "./E6Pagination";
import E6ColumnSet from "./E6ColumnSet";
import E6MessageBox from "./E6MessageBox";
import E6SelectPri from "./E6SelectPri";
import E6SelectRemote from "./E6SelectRemote";
import E6SelectDynamic from "./E6SelectDynamic";

const E6Ui = {
    install: function (Vue) {
        Vue.component(E6FormExtend.name, E6FormExtend);
        Vue.component(E6Title.name, E6Title);
        Vue.component(E6Breadcrumb.name, E6Breadcrumb);
        Vue.component(E6FlankFix.name, E6FlankFix);
        Vue.component(E6Pagination.name, E6Pagination);
        Vue.component(E6ColumnSet.name, E6ColumnSet);
        Vue.component(E6MessageBox.name, E6MessageBox);
        Vue.component(E6SelectPri.name, E6SelectPri);
        Vue.component(E6SelectRemote.name, E6SelectRemote);
        Vue.component(E6SelectDynamic.name, E6SelectDynamic);
    }
};

export default E6Ui;
